import { useState } from 'react';
import styles from './index.module.scss';
import TabBar from './components/TabBar';
import ProductList from './components/ProductList';
import ImgMathCover from '@/assets/productCenter/phonics/math.png';
import ImgMath1 from '@/assets/productCenter/phonics/math-1.png';
import ImgMath2 from '@/assets/productCenter/phonics/math-2.png';
import ImgMath3 from '@/assets/productCenter/phonics/math-3.png';
import ImgMath4 from '@/assets/productCenter/phonics/math-4.png';
import ImgMath5 from '@/assets/productCenter/phonics/math-5.png';
import ImgChineseCover from '@/assets/productCenter/phonics/chinese.png';
import ImgChinese1 from '@/assets/productCenter/phonics/chinese-1.png';
import ImgChinese2 from '@/assets/productCenter/phonics/chinese-2.png';
import ImgChinese3 from '@/assets/productCenter/phonics/chinese-3.png';
import ImgEnglishCover from '@/assets/productCenter/phonics/english.png';
import ImgEnglish1 from '@/assets/productCenter/phonics/english-1.png';
import ImgEnglish2 from '@/assets/productCenter/phonics/english-2.png';
import ImgEnglish3 from '@/assets/productCenter/phonics/english-3.png';
import VideoMath from '@/assets/productCenter/phonics/mind.mp4';
import VideoChinese from '@/assets/productCenter/phonics/humanity.mp4';
import VideoEnglish from '@/assets/productCenter/phonics/bilingualism.mp4';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';

const TAB_TITLES = ['爱学AI思维', '爱学AI人文', '爱学AI双语'];

const PRODUCT_LIST = [
  {
    key: 1,
    bgClass: styles['screen4-bg-1'],
    cover: ImgMathCover,
    video: VideoMath,
    title: '爱学AI思维',
    desc: 'AI赋能下的思维能力培养平台',
    content:
      '爱学AI思维，是AI赋能下的思维能力培养平台。依据低学龄孩子认知发展规律与学习特质，构建了覆盖16种核心思维方法、7大数学模块的完整数学思维培育体系。依托独创GMT教学法（引导思考—构建模型—迁移能力），提供引导式对话的授课体验；让孩子会思考、会应用、会迁移。',
    listTitle: '五大理念保障学习效果',
    list: [
      {
        img: ImgMath1,
        title: '真思维体系',
        desc: '独创GMT真思维训练体系，课上课下双轨学习系统',
        summary: '独创GMT真思维训练体系',
      },
      {
        img: ImgMath2,
        title: '真思维课堂',
        desc: 'GMT教学法，从知识到方法再到思维，让孩子真正学会思考',
        summary: 'GMT教学法，从知识到方法再到思维',
      },
      {
        img: ImgMath3,
        title: '真AI导师',
        desc: '集百位大师教学经验于一身的超级AI导师',
        summary: '集百位大师教学经验于一身的超级AI导师',
      },
      {
        img: ImgMath4,
        title: '真AI互动体验',
        desc: '全开麦引导对话课堂，动手操作、长式手写等多重学习体验',
        summary: '全开麦引导对话课堂',
      },
      {
        img: ImgMath5,
        title: '真个性化学习',
        desc: '学习数据记忆、智能评测、难度动态调整、个性化练习',
        summary: '学习数据记忆、智能评测、难度动态调整',
      },
    ],
  },
  {
    bgClass: styles['screen4-bg-2'],
    key: 2,
    cover: ImgChineseCover,
    video: VideoChinese,
    title: '爱学AI人文',
    desc: '专业级人文素养与读写能力培养平台',
    content:
      '爱学-AI人文，是AI赋能下的专业级人文素养与读写能力培养平台。我们依据学习者的认知发展规律与兴趣特质，构建了覆盖“阅读输入-思辨内化-创作输出”的完整人文素养培育体系。依托爱学AI大模型，我们提供沉浸式、对话式的深度阅读与写作引导体验，并结合首个教育级高拟真数字人导师，实现如影随形、启发思辨的个性化教学效果。',
    listTitle: '三大设计理念保障学习效果',
    list: [
      {
        img: ImgChinese1,
        title: 'AI驱动学习闭环',
        desc: 'AI引导“追问-思考-表达”闭环，训练信息抓取、逻辑分析、概括与深意体会能力。',
        summary: 'AI引导“追问-思考-表达”闭环',
      },
      {
        img: ImgChinese2,
        title: '多模态高频深度互动',
        desc: '融合语音、视频、文本，通过引导式提问和高频反馈拆解思维链，激发主动思考与表达，告别死记硬背。',
        summary: '融合语音、视频、文本多模态交互',
      },
      {
        img: ImgChinese3,
        title: '个性化讲解与练习路径',
        desc: 'AI精准捕捉思维断点，千人千面定制补全方案，针对性强化逻辑，每次学习都提升阅读、思辨与表达能力。',
        summary: 'AI精准捕捉思维断点',
      },
    ],
  },
  {
    bgClass: styles['screen4-bg-3'],
    key: 3,
    cover: ImgEnglishCover,
    video: VideoEnglish,
    title: '爱学AI双语',
    desc: '新课标适配型双语能力培养平台',
    content:
      '爱学AI双语，是 AI 赋能下的新课标适配型双语能力培养平台。我们严格遵循二语习得规律与小学英语学习路径，构建覆盖 「地道输入 — 高效内化 — 阅读输出」的完整英语能力提升体系。依托爱学 AI 大模型与名师教研，打造沉浸式、对话式英语学习体验，结合北美原声外教 + 资深中教Agent协同，实现随时学、开口练、精准提升的个性化教学效果 。',
    listTitle: '三大核心优势 保障学习效果',
    list: [
      {
        img: ImgEnglish1,
        title: '中外教Agent协同',
        desc: '外教AI负责地道口语输入和纠音，中教AI负责能力的内化，一课双效，听说读写全面提升。',
        summary: '外教AI负责地道口语输入和纠音',
      },
      {
        img: ImgEnglish2,
        title: 'AI 全程真互动',
        desc: '全程开口回答、实时语音互动，AI 全程引导追问，每一步都让孩子动脑动口，把语言从一门功课变回一种沟通工具。',
        summary: '全程开口回答、实时语音互动',
      },
      {
        img: ImgEnglish3,
        title: '全程闭环输出',
        desc: '整个过程遵循“情景导入→开口回答→激励反馈→引导探究→实时反馈→自适应规划”完整闭环，知识可积累、能力可迁移。',
        summary: '知识可积累、能力可迁移',
      },
    ],
  },
];

export default function Screen4() {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [videoShow, setVideoShow] = useState<boolean>(false);
  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 0.8,
    animationClassName: styles['screen4-anim-start'],
  });

  const handleVideoPlay = () => {
    setVideoShow(true);
  };
  const handleTabChange = (index: number) => {
    if (videoShow) {
      setVideoShow(false);
    }
    setActiveTab(index);
  };
  const renderProduct = (activeTab: number) => {
    const product = PRODUCT_LIST[activeTab];
    return (
      <div className={`${styles['screen4-product']} ${product.bgClass}`}>
        <div className={styles['screen4-product-cover']}>
          <div className={styles['screen4-product-cover-container']}>
            <h2 className={styles['screen4-product-cover-title']}>{product.title}</h2>
            <h5 className={styles['screen4-product-cover-desc']}>{product.desc}</h5>
            <p className={styles['screen4-product-cover-content']}>{product.content}</p>
          </div>
          <div className={styles['screen4-product-media']}>
            {videoShow ? (
              <video
                className={styles['screen4-product-video']}
                src={product.video}
                autoPlay
                playsInline
                preload="auto"
                controls
                loop
                muted
              />
            ) : (
              <img
                className={styles['screen4-product-img']}
                src={product.cover}
                alt={product.title}
                onClick={handleVideoPlay}
              />
            )}
          </div>
        </div>
        <div className={styles['screen4-product-list-title']}>{product.listTitle}</div>
        <ProductList key={product.key} list={product.list} />
      </div>
    );
  };

  return (
    <section className={styles['screen4-container']} ref={slideInRef.ref}>
      <h2 className={styles['screen4-title']}>产品矩阵</h2>
      <TabBar
        titles={TAB_TITLES}
        active={activeTab}
        onChange={handleTabChange}
        className={styles['screen4-tabbar']}
      />
      {renderProduct(activeTab)}
    </section>
  );
}
